export function UtilityService() {
    'ngInject';
    const svc = { isUndefinedorNull, isDefinedAndNotNull };
    return svc;

    // Implementation
    function isUndefinedorNull(val) {
        return angular.isUndefined(val) || val === null;
    }

    function isDefinedAndNotNull(val) {
        return angular.isDefined(val) && val !== null;
    }
}
